import React from 'react';

const Discover: React.FC = () => (
  <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
    <h1 style={{ color: '#fff', marginBottom: '16px' }}>Discover</h1>
    <p style={{ color: '#9ca3af' }}>Discover people by city — wire to GET /profile/discover when ready.</p>
  </div>
);

export default Discover;
